<template>
  <div
    class="flex flex-col animate-pulse justify-center items-center"
    :class="
      feedType === 'profile' || feedType === 'trending' ? 'h-[50%]' : 'h-[100%]'
    "
  >
    <div class="heartbeat w-[33%]">
      <TenantLogo />
    </div>
    <div class="flex items-center justify-center">
      <p class="mr-2 text-xl text-primary">Loading</p>
      <ion-spinner class="align-bottom text-primary" name="dots" />
    </div>
  </div>
</template>

<script setup>
import TenantLogo from "@/components/tenantcomponents/TenantLogo.vue";
import { IonSpinner } from "@ionic/vue";

const props = defineProps({
  feedType: String,
});
</script>

<style scoped>
.text-primary {
  color: var(--primary-color);
}

@keyframes heartbeat {
  0% {
    transform: scale(1);
  }

  14% {
    transform: scale(1.1);
  }

  28% {
    transform: scale(1);
  }

  42% {
    transform: scale(1.1);
  }

  70% {
    transform: scale(1);
  }
}

.heartbeat {
  animation: heartbeat 2s ease-in-out infinite;
}
</style>
